import api from './axios';

export function createSimulation(data) {
  return api.post('/simulations', data).then(res => res.data);
}

export function listSimulations(userId) {
  return api.get('/simulations', { params: { userId } }).then(res => res.data);
}

export function updateSimulation(id, data) {
  return api.put(`/simulations/${id}`, data).then(res => res.data);
}

export function deleteSimulation(id) {
  return api.delete(`/simulations/${id}`);
}
